import templateStr from 'text!./templates/policy-mailing-address.html';

export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        scope: {
            'address': '='
        },
        controller: ['$scope', function ($scope) {
            $scope.removeLocNumber = function (locationDisplay) {
                if (locationDisplay.indexOf(":") != -1) return locationDisplay.substring(locationDisplay.indexOf(":") + 1);else return locationDisplay;
            };
        }]

    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policy/common/directives/PolicyMailingAddress.js
// module id = 2076
// module chunks = 0